import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取账户信息
export const getAccountCash = async (params: object) => {
  return await POST({
    url: Api.getAccountCash,
    params: {
      ...params
    },
    showError: false
  })
}
// 正常提现
export const toWithDrawal = async (params: object) => {
  return await POST({
    url: Api.toWithDrawal,
    params: {
      ...params
    },
    showError: false
  })
}
// 帮买提现
export const helpBuyToWithDrawal = async (params: object) => {
  return await POST({
    url: Api.helpBuyToWithDrawal,
    params: {
      ...params
    },
    showError: false
  })
}
// 获取提现银行卡列表
export const queryWithdrawBankCard = async (params: object) => {
  return await GET({
    url: Api.queryWithdrawBankCard,
    params: {
      ...params
    },
    showError: false
  })
}
